export default {
    state: {
        hideLogin: true,
        hideSignUp: true,
        hideSuccess: true,
        hideConfirm: true,
        contentIdToDelete: null
    },
    mutations: {
        updateVisionLogin(state) {
            state.hideLogin = !state.hideLogin
        },
        updateVisionSignUp(state) {
            state.hideSignUp = !state.hideSignUp
        },
        updateVisionSuccess(state) {
            state.hideSuccess = !state.hideSuccess
        },
        updateVisionConfirm(state) {
            state.hideConfirm = !state.hideConfirm
        },
        updateContentIdToDelete(state, id) {
            state.contentIdToDelete = id
        },
        hideAllForms(state) {
            state.hideLogin = true
            state.hideSignUp = true
            state.hideSuccess = false
            state.hideConfirm = true
        },
        hideAllModals(state) {
            state.hideLogin = true
            state.hideSignUp = true
            state.hideSuccess = true
            state.hideConfirm = true
        }
    },
    actions: {
        hideAllForms(ctx) {
            ctx.commit('hideAllForms')
        },
        hideAllModals(ctx) {
            ctx.commit('hideAllModals')
        },
        changeVisionLogin(ctx) {
            ctx.commit('updateVisionLogin')
        },
        changeVisionSignUp(ctx) {
            ctx.commit('updateVisionSignUp')
        },
        changeVisionSuccess(ctx) {
            ctx.commit('updateVisionSuccess')
        },
        changeVisionConfirm(ctx, id) {
            if (id !== 'undefined') {
                ctx.commit('updateContentIdToDelete', id)
            } else {
                this.contentIdToDelete = null
            }
            ctx.commit('updateVisionConfirm')
        }
    },
    getters: {
        toogleLogin(state) {
            return state.hideLogin
        },
        toogleSignUp(state) {
            return state.hideSignUp
        },
        toogleSuccess(state) {
            return state.hideSuccess
        },
        toogleConfirm(state) {
            return state.hideConfirm
        },
        contentId(state) {
            return state.contentIdToDelete
        }
    },
}
